<template>
  <div class="m-not-found">
    <h1>Oops!</h1>
    <h3 class="margin-top-zero">
      La página que estás buscando no está aquí.
    </h3>
    <router-link
      class="text-color-academy-primary text-weight-bold"
      :to="{ name: 'home' }"
    >
      Volver a la página de inicio
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'MoleculeNotFound'
}
</script>
